import { useSelector } from 'react-redux';
import { defaultPepInfo } from '../constants';
import { TClientPep } from '../types';
import { useMemo } from 'react';
import { parseFullName } from '../utils';
import { selectFullName, selectOwners } from '~/store/identification-form/selectors';

export const useGetDefaultPepInfo = (index: number): TClientPep => {
  const fullName = useSelector(selectFullName);

  const owners = useSelector(selectOwners) || {};

  return useMemo(() => {
    if (owners?.length) {
      const beneficiary = owners.filter((item) => item.isBeneficiary)?.[index];

      const beneficiaryFullName = `${beneficiary?.lastName || ''} ${
        beneficiary?.firstName || ''
      } ${beneficiary?.middleName || ''}`.trim();

      return {
        ...defaultPepInfo,
        fullName: beneficiaryFullName,
        ...parseFullName(beneficiaryFullName),
      };
    }

    return {
      ...defaultPepInfo,
      fullName: fullName || '',
      ...parseFullName(fullName || ''),
    };
  }, [owners, fullName, index]);
};
